import { AnimationBaseController, IAnimationControllerConfiguration, Inject } from "@denishussar/html5-game-engine";
import { AnimationContents } from "../../../AnimationContents";
import { ButtonController, IButtonControllerOptions } from "../../Common/ButtonController";
import { GreenButtonTextStyle, TitleTextStyle } from '../../Constants/TextStyles';
import { LocalizationContents } from "../../LocalizationContents";
import isMobile from 'is-mobile';

export interface IFTUEPopupEndControllerOptions {
    onClick: (status: boolean) => {}
}

export class FTUEPopupEndController extends AnimationBaseController {
    
    $model: any;
    
    constructor (
        @Inject private options: IFTUEPopupEndControllerOptions,
    ) {
        super('FTUEPopupEndController');
    }

    protected getConfiguration(): IAnimationControllerConfiguration {
        return <IAnimationControllerConfiguration>{
            animationContent: isMobile() ? AnimationContents.GAME_SCREEN_MOBILE_JSON : AnimationContents.GAME_SCREEN_JSON,
            libraryName: 'ftue_popup_end',
            childControllers: {
                btn: {
                    instanceName: 'ftue_btn',
                    controller: ButtonController,
                    model: this.$model,
                    options: <IButtonControllerOptions>{
                        label: LocalizationContents.getText('Next'),
                        onClick: (status: boolean) => {
                            if (this.options.onClick) {
                                this.options.onClick(status);
                            }
                        },
                    },
                },
            }
        }
    }
    protected onInitialize(): void {
        this.setTextStyleByQuery('ftue_btn.label', GreenButtonTextStyle);
        this.setTextByQuery('txt_content', LocalizationContents.getText('end tutorial'));
        this.setTextByQuery('txt_title', LocalizationContents.getText('Prompt title2'));
        this.setTextStyleByQuery('txt_title', TitleTextStyle);
    }
}
